(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7018],{

/***/ 67018:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Reason_Download; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(93288);
// EXTERNAL MODULE: ./node_modules/@c10h/colors/es/palette.js
var palette = __webpack_require__(45602);
// EXTERNAL MODULE: ./node_modules/moment-timezone/index.js
var moment_timezone = __webpack_require__(50995);
var moment_timezone_default = /*#__PURE__*/__webpack_require__.n(moment_timezone);
// EXTERNAL MODULE: ./src/i18n.ts + 5 modules
var src_i18n = __webpack_require__(76361);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(32466);
// EXTERNAL MODULE: ./src/hooks/useGetSoonestTime.ts
var useGetSoonestTime = __webpack_require__(46102);
// EXTERNAL MODULE: ./src/components/_common/_constants.ts + 1 modules
var _constants = __webpack_require__(93932);
// EXTERNAL MODULE: ./src/components/_common/Carbon.tsx
var Carbon = __webpack_require__(29946);
// EXTERNAL MODULE: ./src/components/_common/LazyComp.tsx
var LazyComp = __webpack_require__(90008);
;// CONCATENATED MODULE: ./src/components/v5/ReadableSlotTimeBySpecialtyId.tsx
/* eslint-disable react/jsx-no-useless-fragment */ 







const ReadableSlotTimeBySpecialtyId = (param)=>{
    let { specialtyId  } = param;
    const i18n = (0,src_i18n/* useTranslation */.$G)();
    const maybeSlot = (0,useGetSoonestTime/* useGetSoonestInPracticeBySpecialtyId */.zn)({
        specialtyId
    });
    const nextApptSlotTime = (0,Carbon/* todayTomorrow4 */.xf)(i18n.lang, maybeSlot === null || maybeSlot === void 0 ? void 0 : maybeSlot.time);
    if (_constants/* isCI */.yg) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: moment_timezone_default()(_constants/* fakeTimestamp */.cS).format("ddd, MMM Do")
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(LazyComp/* LazyComp */.P, {
        children: nextApptSlotTime
    });
};

// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(21395);
var router_default = /*#__PURE__*/__webpack_require__.n(router);
// EXTERNAL MODULE: ./src/constants/specialtyIds.ts
var specialtyIds = __webpack_require__(93209);
// EXTERNAL MODULE: ./src/store/index.ts + 6 modules
var store = __webpack_require__(40367);
// EXTERNAL MODULE: ./src/constants/practiceIds.ts
var practiceIds = __webpack_require__(34557);
// EXTERNAL MODULE: ./src/components/v5/NextImage.tsx + 1 modules
var NextImage = __webpack_require__(5621);
// EXTERNAL MODULE: ./src/components/v5/TextMeApp.tsx + 1 modules
var TextMeApp = __webpack_require__(30545);
// EXTERNAL MODULE: ./src/components/v5/V5Comp.tsx
var V5Comp = __webpack_require__(63575);
;// CONCATENATED MODULE: ./src/components/v5/Reason/Download.tsx














const Download = (param)=>{
    let { trackingLabel  } = param;
    const { practices , isMobile  } = (0,store/* useTypedSelector */.ix)((param)=>{
        let { config  } = param;
        return config;
    });
    const carbonPractice = practices === null || practices === void 0 ? void 0 : practices.findById(practiceIds/* PracticeId.CARBON */.I.CARBON);
    const { downloadDeepLink , slug  } = carbonPractice || {
        downloadDeepLink: "https://crbn.app.link/nijKU2YXJH",
        slug: "direct-urgent-care"
    };
    const i18n = (0,src_i18n/* useTranslation */.$G)();
    const downloadLinkAnalyticsConfig = ()=>(0,Carbon/* trackToPatient */.Zr)({
            ga: {
                category: "Download app",
                action: "SMS from virtual care scheduling force DL",
                label: trackingLabel || (router_default()).pathname
            }
        });
    const downloadLinkAnalyticsConfigMobile = ()=>{
        (0,Carbon/* trackToPatient */.Zr)({
            ga: {
                category: "Download app",
                action: "Link to app store",
                label: trackingLabel || (router_default()).pathname
            }
        });
    };
    const header = i18n.t("Get treated right from your phone.");
    const downloadImagePath = "reason/download/main";
    const mobileImagePath = "reason/download/main_mobile";
    const checkmarkSrc = "reason/download/check";
    const defaultItems = [
        i18n.t("Book same-day appointments"),
        i18n.t("Talk to a provider in real time"),
        i18n.t("Get care from the comfort of home"),
        i18n.t("Most insurance accepted")
    ];
    const mobileListItems = [
        i18n.t("Same-day appointments"),
        i18n.t("Chat wherever you are"),
        i18n.t("Accepts most insurance")
    ];
    const listItems = isMobile ? mobileListItems : defaultItems;
    const id = "download-app-heading";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        "aria-labelledby": id,
        className: "ph32 ph8-md pv18 pv8-md ph4-f-xl pb0-f contrast-tbt",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "df fdrr maxw85 ma",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "fx df fdc aic-md",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(LazyComp/* LazyComp */.P, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                className: "font-mb mb6 ttu fs12 darkGreen tac-md fsn hide-in-percy",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ReadableSlotTimeBySpecialtyId, {
                                    specialtyId: specialtyIds/* SpecialtyId.VIRTUAL_URGENT_CARE */.mg.VIRTUAL_URGENT_CARE
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            id: id,
                            className: "font-cm fs40 fs24-md mb6 maxw30 tac-md",
                            children: header
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "mb6 tac-md",
                            children: isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)(V5Comp/* Btn */.un, {
                                bg: palette.darkGreen,
                                color: "#fff",
                                fontSize: 1,
                                href: downloadDeepLink,
                                onClick: downloadLinkAnalyticsConfigMobile,
                                children: i18n.t("Get the App")
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(TextMeApp/* default */.Z, {
                                downloadDeepLink: downloadDeepLink,
                                practiceSlug: slug,
                                gA: downloadLinkAnalyticsConfig,
                                inputStyle: {
                                    backgroundColor: palette.gray100 + 80
                                }
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                            className: "gray400 fs12 lh17 font-ml mb28 mb8-md tac-md font-mb ttu ls2",
                            children: i18n.t("Available in the App Store and Google Play")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "df aic",
                            children: [
                                isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "fx tac",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NextImage/* default */.Z, {
                                        src: mobileImagePath,
                                        width: 164,
                                        height: 313,
                                        alt: i18n.t("An illustration of a mobile phone during a virtual appointment with a Carbon Health provider, who is smiling.")
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                    className: "fx",
                                    children: listItems.map((item, key)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                            className: "df aic mb14 mb6-md",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "w6",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NextImage/* default */.Z, {
                                                        src: checkmarkSrc,
                                                        height: 35,
                                                        width: 31,
                                                        layout: "responsive",
                                                        alt: ""
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "gray800 fx font-cm fs24 fs16-md fs12-xs ml6 ml2-md lh14",
                                                    children: item
                                                })
                                            ]
                                        }, key))
                                })
                            ]
                        })
                    ]
                }),
                !isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "fx dn-md mr8",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NextImage/* default */.Z, {
                        src: downloadImagePath,
                        className: "ase",
                        alt: i18n.t("An illustration of a mobile phone during a virtual appointment with a Carbon Health provider, who is smiling."),
                        width: "639",
                        height: "984",
                        layout: "responsive"
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var Reason_Download = (Download);


/***/ }),

/***/ 30545:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ TextMeApp; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(93288);
// EXTERNAL MODULE: ./src/utils/fetch/fetches.ts + 2 modules
var fetches = __webpack_require__(54428);
;// CONCATENATED MODULE: ./src/_services/website/downloadLink.ts

const sendDownloadLink = async (param)=>{
    let { phone , practiceSlug , csrfToken , captcha  } = param;
    const response = await (0,fetches/* nextApi */.t)()("/api/download-link", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "CSRF-Token": csrfToken || "null"
        },
        credentials: "same-origin",
        body: JSON.stringify({
            phone,
            practiceSlug,
            captcha
        })
    });
    return response.json();
};

// EXTERNAL MODULE: ./src/i18n.ts + 5 modules
var src_i18n = __webpack_require__(76361);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(32466);
// EXTERNAL MODULE: ./node_modules/react-google-recaptcha/lib/esm/index.js + 3 modules
var esm = __webpack_require__(62276);
// EXTERNAL MODULE: ./node_modules/react-intl-tel-input/dist/index.js
var dist = __webpack_require__(18462);
// EXTERNAL MODULE: ./src/store/index.ts + 6 modules
var store = __webpack_require__(40367);
// EXTERNAL MODULE: ./src/components/_common/Carbon.tsx
var Carbon = __webpack_require__(29946);
// EXTERNAL MODULE: ./src/components/v5/TextMeApp.module.scss
var TextMeApp_module = __webpack_require__(60391);
var TextMeApp_module_default = /*#__PURE__*/__webpack_require__.n(TextMeApp_module);
;// CONCATENATED MODULE: ./src/components/v5/TextMeApp.tsx









var SubmitStatus;
(function(SubmitStatus) {
    SubmitStatus[SubmitStatus["WAITING"] = 0] = "WAITING";
    SubmitStatus[SubmitStatus["SENT"] = 1] = "SENT";
    SubmitStatus[SubmitStatus["ERROR"] = 2] = "ERROR";
})(SubmitStatus || (SubmitStatus = {}));
const TextmeApp = (param)=>{
    let { downloadDeepLink , practiceSlug , gA , action ="Download app" , inputStyle ={}  } = param;
    const { isMobile , recaptchaClientKey , csrfToken  } = (0,store/* useTypedSelector */.ix)((param)=>{
        let { config  } = param;
        return config;
    });
    const i18n = (0,src_i18n/* useTranslation */.$G)();
    const recaptchaRef = (0,react.useRef)(null);
    const [submitStatus, setSubmitStatus] = (0,react.useState)(SubmitStatus.WAITING);
    const [phoneNumber, setPhoneNumber] = (0,react.useState)(null);
    const getPhone = ()=>{
        var _document_getElementById;
        return (_document_getElementById = document.getElementById("phone-number-input")) === null || _document_getElementById === void 0 ? void 0 : _document_getElementById.getElementsByClassName("phone")[0];
    };
    (0,react.useEffect)(()=>{
        const phone = getPhone();
        if (phone) {
            phone.setAttribute("required", "true");
        }
    }, []);
    const handleSubmit = async (e)=>{
        e.preventDefault();
        const captcha = recaptchaRef.current ? await recaptchaRef.current.executeAsync() : null;
        sendDownloadLink({
            phone: phoneNumber,
            practiceSlug,
            csrfToken,
            captcha
        }).then(()=>{
            setSubmitStatus(SubmitStatus.SENT);
            (0,Carbon/* trackToPatient */.Zr)({
                ga: {
                    category: "Download app",
                    action,
                    label: "download"
                }
            });
        }).catch(()=>{
            setSubmitStatus(SubmitStatus.ERROR);
        });
    };
    const handlePhoneNumberChange = (status, _value, _countryData, number)=>{
        const phone = getPhone();
        if (status && phone) {
            phone.removeAttribute("pattern");
        } else if (phone) {
            phone.setAttribute("required", "true");
            phone.setAttribute("pattern", "abc");
        }
        setPhoneNumber(number);
    };
    return isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (TextMeApp_module_default()).mobile,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            href: downloadDeepLink,
            className: (TextMeApp_module_default()).downlaodBtn,
            onClick: ()=>gA && gA(),
            children: i18n.t("Get the Carbon Health App")
        })
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: submitStatus === SubmitStatus.WAITING ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
            id: "phone-number-input",
            onSubmit: handleSubmit,
            className: (TextMeApp_module_default()).form,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                    autoPlaceholder: false,
                    inputClassName: "phone",
                    defaultCountry: "us",
                    placeholder: i18n.t("Phone number"),
                    format: true,
                    style: inputStyle,
                    onPhoneNumberChange: handlePhoneNumberChange
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    className: "".concat((TextMeApp_module_default()).btn, " btn btn-genoa"),
                    type: "submit",
                    children: i18n.t("Text Me the App")
                }),
                recaptchaClientKey ? /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* default */.Z, {
                    ref: recaptchaRef,
                    sitekey: recaptchaClientKey,
                    size: "invisible"
                }) : null
            ]
        }) : submitStatus === SubmitStatus.ERROR ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "btn pen",
                    children: i18n.t("Something went wrong!")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    className: "color-brand di brdn bg-inherit cp us font-cm",
                    onClick: ()=>setSubmitStatus(SubmitStatus.WAITING),
                    children: i18n.t("Try again.")
                })
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "btn btn-genoa pen df aic",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "cIcon-check-rounded fs14 mr2 gray50 di"
                        }),
                        i18n.t("Text Sent Successfully!")
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                    className: "mt4",
                    children: [
                        i18n.t("It didn't work?"),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            className: "color-brand di brdn bg-inherit cp us font-cm",
                            onClick: ()=>setSubmitStatus(SubmitStatus.WAITING),
                            children: i18n.t("Try again.")
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var TextMeApp = (TextmeApp);


/***/ }),

/***/ 46102:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "wE": function() { return /* binding */ useGetSoonestTimeByLocationsAndSpecialtyIds; },
/* harmony export */   "xz": function() { return /* binding */ getSortedSoonestLocationWithAvailableSlotBySpecialty; },
/* harmony export */   "zn": function() { return /* binding */ useGetSoonestInPracticeBySpecialtyId; }
/* harmony export */ });
/* unused harmony export getSoonestSlotFromApptSlotBlock */
/* harmony import */ var moment_timezone__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50995);
/* harmony import */ var moment_timezone__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(moment_timezone__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(21395);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32466);
/* harmony import */ var src_store_slices_userLocation__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(36330);
/* harmony import */ var _services_api__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(95832);
/* harmony import */ var _services_featureFlagConstants__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(72714);
/* harmony import */ var _components_common_constants__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(93932);
/* harmony import */ var _constants_practiceIds__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(34557);
/* harmony import */ var _store__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(40367);
/* harmony import */ var _utils_fetchCachedSlotAround__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(39815);
/* harmony import */ var _useFeatureFlags__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(15343);











const getSoonestSlotFromApptSlotBlock = (slotTimes)=>{
    var _slotTimes_, _slotTimes__;
    return slotTimes === null || slotTimes === void 0 ? void 0 : (_slotTimes_ = slotTimes[0]) === null || _slotTimes_ === void 0 ? void 0 : (_slotTimes__ = _slotTimes_[0]) === null || _slotTimes__ === void 0 ? void 0 : _slotTimes__.time;
};
const useGetSoonestInPracticeBySpecialtyId = (param)=>{
    let { specialtyId , practiceId =_constants_practiceIds__WEBPACK_IMPORTED_MODULE_7__/* .PracticeId.CARBON */ .I.CARBON , daysCount =7  } = param;
    const { pageLoaded , practices , locations  } = (0,_store__WEBPACK_IMPORTED_MODULE_8__/* .useTypedSelector */ .ix)((param)=>{
        let { config  } = param;
        return config;
    });
    const [slot, setSlot] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)({});
    const enableCache = (0,_useFeatureFlags__WEBPACK_IMPORTED_MODULE_10__/* .useFeatureFlag */ .y)(_services_featureFlagConstants__WEBPACK_IMPORTED_MODULE_5__/* .FeatureFlag.GROWTH_CACHED_SLOTS_ENABLED */ .T.GROWTH_CACHED_SLOTS_ENABLED);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(()=>{
        if (!pageLoaded || enableCache === undefined) return;
        if (enableCache) {
            (0,_utils_fetchCachedSlotAround__WEBPACK_IMPORTED_MODULE_9__/* .fetchCachedSlotAround */ .o)({
                locations,
                specialtyId
            }).then(setSlot);
        } else {
            var _locations_filter_;
            // @ts-expect-error TS2532: Object is possibly 'undefined'.
            const virtualSpecialtyIds = practices.flatMap((p)=>p.specialties.vals()).filter((s)=>s.isVirtual).map((s)=>s.id).distinct();
            const isVirtual = virtualSpecialtyIds.includes(specialtyId);
            // if virtual care, ignore closest location
            const closestLocationPracticeId = !isVirtual && ((_locations_filter_ = locations.filter((l)=>l.specialtyIds.includes(specialtyId))[0]) === null || _locations_filter_ === void 0 ? void 0 : _locations_filter_.practiceId);
            const finalPracticeId = practiceId || closestLocationPracticeId || _constants_practiceIds__WEBPACK_IMPORTED_MODULE_7__/* .PracticeId.CARBON */ .I.CARBON;
            const now = +moment_timezone__WEBPACK_IMPORTED_MODULE_0___default()();
            // @ts-expect-error TS2532, TS2684, TS2532: Object is possibly 'undefined'.,  The 'this' context of type 'RootStatePractice[] | undefined' is not assignable to method's 'this' of type 'RootStatePractice[]'.,  Object is possibly 'undefined'.
            const specialty = practices.findById(finalPracticeId).specialties[specialtyId] || {};
            const { defaultNewPatientApptDuration: duration = 10 , apptLeadTime =0  } = specialty;
            const from = (apptLeadTime * _components_common_constants__WEBPACK_IMPORTED_MODULE_6__/* .millisPerMinute */ .NM || 0) < 0 ? now : now + apptLeadTime; // check if from is in past
            const to = +moment_timezone__WEBPACK_IMPORTED_MODULE_0___default()(now).add(daysCount, "days").endOf("day");
            (0,_services_api__WEBPACK_IMPORTED_MODULE_4__/* .loadAvailableSlots */ .vk)({
                practiceId: finalPracticeId,
                from,
                to,
                duration,
                specialtyId,
                timezone: _components_common_constants__WEBPACK_IMPORTED_MODULE_6__/* .laTimezone */ .$A
            }).then((slots)=>{
                var _slots_;
                setSlot((slots === null || slots === void 0 ? void 0 : (_slots_ = slots[0]) === null || _slots_ === void 0 ? void 0 : _slots_[0]) || {});
            });
        }
    }, [
        pageLoaded,
        enableCache
    ]);
    return slot || null;
};
const useGetSoonestTimeByLocationsAndSpecialtyIds = (param)=>{
    let { locations , specialtyIds , daysCount =21 , specialtyCount =1 , locationCount =3  } = param;
    const { pageLoaded , locations: allLocations  } = (0,_store__WEBPACK_IMPORTED_MODULE_8__/* .useTypedSelector */ .ix)((param)=>{
        let { config  } = param;
        return {
            ...config
        };
    });
    const selectedRegion = (0,_store__WEBPACK_IMPORTED_MODULE_8__/* .useTypedSelector */ .ix)(src_store_slices_userLocation__WEBPACK_IMPORTED_MODULE_3__/* .selectSelectedRegion */ .dz);
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    const [slotLocationWithTime, setSlotLocationWithTime] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)({});
    const enableCache = (0,_useFeatureFlags__WEBPACK_IMPORTED_MODULE_10__/* .useFeatureFlag */ .y)(_services_featureFlagConstants__WEBPACK_IMPORTED_MODULE_5__/* .FeatureFlag.GROWTH_CACHED_SLOTS_ENABLED */ .T.GROWTH_CACHED_SLOTS_ENABLED);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(()=>{
        if (!pageLoaded || enableCache === undefined) return;
        const now = +moment_timezone__WEBPACK_IMPORTED_MODULE_0___default()();
        (locations || allLocations.slice(0, locationCount)).map((l)=>{
            const sortedSpecialties = l.specialties.vals().sortBy("sortIndex").slice(0, specialtyCount);
            return (specialtyIds || sortedSpecialties.map((s)=>s.id) // if specialIds param is null, try with first specialtyId
            ).map((sId)=>{
                const { defaultNewPatientApptDuration: duration = 10 , apptLeadTime =0  } = l.specialties[sId] || {};
                const from = (apptLeadTime * _components_common_constants__WEBPACK_IMPORTED_MODULE_6__/* .millisPerMinute */ .NM || 0) < 0 ? now : now + apptLeadTime; // check if from is in past
                return (0,_services_api__WEBPACK_IMPORTED_MODULE_4__/* .loadAvailableSlots */ .vk)({
                    practiceId: l.practiceId,
                    locationId: l.id,
                    from,
                    to: +moment_timezone__WEBPACK_IMPORTED_MODULE_0___default()(now).add(daysCount, "days").endOf("day"),
                    duration,
                    specialtyId: sId,
                    timezone: l.timezone || _components_common_constants__WEBPACK_IMPORTED_MODULE_6__/* .laTimezone */ .$A,
                    enableCache
                }).then((slotTimes)=>({
                        lId: l.id,
                        sId,
                        slotTime: getSoonestSlotFromApptSlotBlock(slotTimes)
                    }));
            }).sequence();
        }).sequence().then((locationsAndSlot)=>{
            setSlotLocationWithTime(locationsAndSlot.flat().groupBy("lId").mapValues((slots)=>slots.groupBy("sId").mapValues((slots)=>slots[0].slotTime)));
        });
    }, [
        pageLoaded,
        router.asPath,
        selectedRegion,
        enableCache
    ]);
    return slotLocationWithTime;
};
/* get first location with soonest specialty in location list
eg (assuming sf's urgentcare slot is sooner):
({locations: [berkeley, sf],specialtyId: UrgentCareId}) => {locationId: [sfLocationId]: time: 1666666} */ const getSortedSoonestLocationWithAvailableSlotBySpecialty = (param)=>{
    let { locationsWithSlots , specialtyId  } = param;
    if (locationsWithSlots.isOEmpty()) {
        // @ts-expect-error TS2322: Type 'null' is not assignable to type 'string'.
        return {
            locationId: null
        };
    }
    return locationsWithSlots.toArray()// @ts-expect-error TS2571: Object is of type 'unknown'.
    .sortBy((l)=>l[1][specialtyId])// @ts-expect-error TS2571: Object is of type 'unknown'.
    .map((l)=>({
            locationId: l[0],
            time: l[1][specialtyId]
        }))[0];
};


/***/ }),

/***/ 60391:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"form":"TextMeApp_form__DD_b8","btn":"TextMeApp_btn__X5Y8U","mobile":"TextMeApp_mobile__ItCrX","downlaodBtn":"TextMeApp_downlaodBtn__FZmVn"};

/***/ })

}]);